import { useEffect } from "react";
import Lenis from "lenis";

export function useLenis() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    // Only smooth the mouse wheel on real desktops. On touch devices Lenis' virtual
    // scroll can desync from native touch scrolling and cause "glitchy" jumps.
    const isDesktop = window.matchMedia("(min-width: 1024px) and (pointer: fine)").matches;
    if (!isDesktop) return;

    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      if (window.__lenis === lenis) window.__lenis = null;
    };
  }, []);
}

export function resolveHashTarget(selector) {
  let el = document.querySelector(selector);
  if (!el && typeof selector === "string" && selector.startsWith("#")) {
    const name = selector.slice(1);
    el = document.querySelector(`[data-testid="${name}"]`) || document.getElementsByName(name)[0];
  }
  return el || null;
}

// Scroll to an element by CSS selector, accounting for the fixed navbar.
// Uses Lenis when available (avoids conflicts with smooth-wheel), else native.
export function scrollToSelector(selector, offset = -90) {
  const el = resolveHashTarget(selector);
  if (!el) return false;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset, duration: 1.0 });
  } else {
    const top = el.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: "smooth" });
  }
  return true;
}

